import { baseUrl } from "./config";

export const getTestimonials = async () => {
  try {
    const result = await fetch(`${baseUrl}/statements/`);

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const getTestimonials = async () => {
    let list = [];
    return firebase.firestore().collection('testimonials').get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                list.push(doc.data());
            })
            return list;
        })
        .catch(error => {
            console.log(error)
            return {error: true};
        })
} */
